<template>
  <div class="container mt-5">
    <div class="row d-flex justify-content-center">
      <div class="col-md-6">
        <div v-if="errors">
          <b-alert show variant="danger">Неверный Email или телефон</b-alert>
        </div>
        <div class="card px-3 px-md-5 py-5" id="form1">
          <div class="form-data">
            <div class="forms-inputs mb-4" :class="{ 'shake-animation': shakeEmail }">
              <b-icon icon="envelope" variant="secondary"></b-icon>
              <span> Email</span>
              <input
                  autocomplete="off"
                  type="email"
                  class="form-control"
                  :class="emailValidationClass"
                  v-model="email"
                  required>
            </div>
            <div class="forms-inputs mb-4" :class="{ 'shake-animation': shakePhone }">
              <b-icon icon="phone" variant="secondary"></b-icon>
              <span>Телефон</span>
              <input
                  autocomplete="off"
                  type="text"
                  class="form-control"
                  :class="phoneValidationClass"
                  v-model="phone"
                  @input="onPhoneInput"
                  placeholder="+7 (___) ___-__-__"
                  maxlength="18"
                  required>
            </div>
            <div class="mb-3">
              <!-- Убрали disabled, теперь кнопка всегда кликабельна, но выглядит выключенной через класс -->
              <button
                  @click="loginSubmit"
                  class="btn w-100"
                  :class="isFormValid ? 'btn-dark' : 'btn-disabled'">
                Вход
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      email: null,
      phone: null,
      errors: false,
      shakeEmail: false, // Флаг для тряски поля email
      shakePhone: false  // Флаг для тряски поля телефона
    }
  },
  computed: {
    isEmailValid() {
      if (!this.email) return false;
      const re = /^[a-zA-Z0-9._+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
      return re.test(String(this.email).toLowerCase());
    },
    emailValidationClass() {
      if (!this.email && !this.shakeEmail) return '';
      return this.isEmailValid ? 'is-valid' : 'is-invalid';
    },

    phoneValidationClass() {
      if (!this.phone && !this.shakePhone) return '';
      if (this.phone && this.phone.length === 18) {
        return 'is-valid';
      } else {
        return 'is-invalid';
      }
    },
    isPhoneValid() {
      return this.phone && this.phone.length === 18;
    },

    isFormValid() {
      return this.isPhoneValid && this.isEmailValid;
    }
  },
  methods: {
    onPhoneInput(e) {
      let rawValue = e.target.value;
      let input = rawValue.replace(/\D/g, '');
      let formatted = '';

      if (!input) {
        this.phone = rawValue.includes('+') ? '+' : '';
        return;
      }

      if (e.inputType === 'deleteContentBackward' && input.length === 1) {
        this.phone = '';
        return;
      }

      let numberPart = input;

      if (input[0] === '7' || input[0] === '8') {
        numberPart = input.substring(1);
      }

      numberPart = numberPart.substring(0, 10);

      formatted = '+7 ';

      if (numberPart.length > 0) {
        formatted += '(' + numberPart.substring(0, 3);
      }
      if (numberPart.length >= 4) {
        formatted += ') ' + numberPart.substring(3, 6);
      }
      if (numberPart.length >= 7) {
        formatted += '-' + numberPart.substring(6, 8);
      }
      if (numberPart.length >= 9) {
        formatted += '-' + numberPart.substring(8, 10);
      }

      this.phone = formatted;
    },

    // Метод для запуска анимации тряски
    triggerShake() {
      if (!this.isEmailValid) {
        this.shakeEmail = true;
        setTimeout(() => { this.shakeEmail = false; }, 500); // Отключаем класс через 0.5с
      }
      if (!this.isPhoneValid) {
        this.shakePhone = true;
        setTimeout(() => { this.shakePhone = false; }, 500);
      }
    },

    loginSubmit(e) {
      e.preventDefault();

      // Если форма не валидна, трясем незаполненные/неверные поля и прерываем выполнение
      if (!this.isFormValid) {
        this.triggerShake();
        return;
      }

      // Если все ок, отправляем данные
      let cleanPhone = '+' + this.phone.replace(/\D/g, '');

      this.$http.post(`${process.env.VUE_APP_API_URL}/auth/login/`, {
        email: this.email,
        phone: cleanPhone
      }).then(response => {
        if (response.status === 200) {
          if (response.data.token != null) {
            localStorage.setItem('jwt', response.data.token)
            this.$http.defaults.headers.common['Authorization'] = 'Bearer ' + localStorage.getItem('jwt')
            this.$emit('loggedIn')
            if (this.$route.params.nextUrl != null) {
              this.$router.push(this.$route.params.nextUrl)
            } else {
              this.$router.push({name: 'subscribe'})
            }
          } else {
            this.errors = true;
            throw new Error();
          }
        }
      })
          .catch(error => {
            this.errors = true;
          });
    }
  }
}
</script>

<style>
body {
  overflow-x: hidden;
}
</style>

<style scoped>
.form-control::placeholder {
  color: #adb5bd;
  opacity: 1;
}

.form-control:-ms-input-placeholder {
  color: #adb5bd;
  opacity: 1;
}

.form-control::-ms-input-placeholder {
  color: #adb5bd;
  opacity: 1;
}

.form-control.is-valid, .form-control.is-invalid {
  background-image: none;
  padding-right: 0.75rem;
}

/* Стили для выключенной кнопки (вместо атрибута disabled) */
.btn-disabled {
  background-color: #f1f3f5;
  border-color: #f1f3f5;
  color: #adb5bd;
  cursor: pointer; /* Оставляем курсор, чтобы было понятно, что можно нажать */
}

.btn-disabled:hover {
  background-color: #e9ecef;
  border-color: #e9ecef;
}

/* Анимация тряски (shake) */
@keyframes shake {
  0%, 100% { transform: translateX(0); }
  10%, 30%, 50%, 70%, 90% { transform: translateX(-5px); }
  20%, 40%, 60%, 80% { transform: translateX(5px); }
}

.shake-animation {
  animation: shake 0.5s;
}
</style>